<template>
    <!--弹窗-->
    <el-dialog
        width="650px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" :rules="rules" :inline="true">

            <el-form-item label="国家: " prop="state">
                <el-select
                    v-model="formData.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in $common.us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类目名称:" prop="name">
                <el-input style="width: 150px;" clearable v-model="formData.name" placeholder="请输入类目名称"
                          size="mini"></el-input>
            </el-form-item>

            <el-button type="primary" @click="getCategoryList" size="small">查询</el-button>

        </el-form>

        <el-table :row-key="getRowKeys" v-loading="loading" :data="list" height="400" size="mini" ref="multipleTable"
                  class="table_content mini_div" border style="width: 100%;">
            <el-table-column label="亚马逊类目id" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.catId }}</div>
                </template>
            </el-table-column>

            <el-table-column label="类目名" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="产品数" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.productCount }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="chooseFunc(scope.row)" size="small">选择</el-button>
                </template>
            </el-table-column>


        </el-table>

        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >关 闭
            </el-button
            >
        </el-row>

        <chooseRootCategory :visible="addRootCategoryModal" @chooseInfoFunc="chooseInfoFunc"
                            @close-callback="addRootCategoryModal=false"></chooseRootCategory>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import chooseRootCategory from './chooseRootCategory.vue'
import {keepa_keepa_root_category_add} from '@/api/advAnalys/advAnalys.js'

export default {
    components: {chooseRootCategory},
    data() {
        return {
            addRootCategoryModal: false,
            loading: false,
            options: [],
            list: [],
            rules: {
                state: [
                    {
                        required: true,
                        message: '请选择国家',
                        trigger: 'blur'
                    },
                ],
                name: [
                    {
                        required: true,
                        message: '请输入类目名称',
                        trigger: 'blur'
                    },
                ]
            },
            formData: {
                state: '',
                name: '',
            },
            chooseInfo: {},
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
    },
    methods: {
        getRowKeys(row) {
            return row.catId
        },
        chooseFunc(data) {
            this.$confirm('确认添加此根目录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.chooseInfo = data
                this.addRootCategory()
            })
        },
        chooseInfoFunc(data) {
            this.chooseInfo =  data
        },
        addRootCategory() {
            this.$refs['formData'].validate(valid => {
                if (valid) {
                    if(!this.chooseInfo.catId) {
                        this.$message.info('请选择类目名')
                        return
                    }
                    this.loading = true
                    api.keepa_keepa_root_category_add({...this.formData, catId: this.chooseInfo.catId}).then(res => {
                        if (res.code === 0) {
                            this.loading = false;
                            this.$message({type: "success", message: "添加成功"});
                            this.handleClose(true);
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })
        },
        getCategoryList() {
            this.loading = true

            this.$refs['formData'].validate(valid => {
                if (valid) {
                    api.keepa_keepa_root_category_search(this.formData).then(res => {
                        if (res.code === 0) {
                            this.list = (res.data || []).map(item => {
                                return {
                                    'catId': item.catId,
                                    'name': item.name,
                                    'contextFreeName': item.contextFreeName,
                                    'productCount': item.productCount
                                }
                            })
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })

        },
        // 保存信息
        submitForm() {
            if (this.chooseInfo == null) {
                this.$message.info('请选择一个类目')
                return
            }
            this.$emit('chooseInfo', this.chooseInfo)
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.formData = {
                state: '',
                name: '',
            }
            this.list = []
            this.chooseInfo = {};
            this.$refs['formData'].resetFields()
            this.loading = false
            this.$emit('close-callback', isshow)
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
